export default function PHP_connection_aborted() {
  return (
    <div>
      <h1>PHP_connection_aborted</h1>
    </div>
  );
}
